import { useState } from 'react';

const LIGHTBOX_IMAGE = 'https://static.readdy.ai/image/ec6c134e43b902bc81c674ec061ba5f4/4643be0110369a66cf3695f8d56b8318.png';
const LIGHTBOX_IMAGE_VTUBER = 'https://static.readdy.ai/image/ec6c134e43b902bc81c674ec061ba5f4/bd9db383d5f039ce74a96d828af2a58c.jpeg';
const LIGHTBOX_IMAGE_THUMBNAIL = 'https://storage.readdy-site.link/project_files/ad497236-385f-4b6e-bb69-bc2f03e1f0bd/a2f2867d-d742-478b-ba01-fd695a7f1532_thumbnail_letsplay.webp?v=03e3d482970da0ee2433f9d1468ae5cb';
const LIGHTBOX_IMAGE_MERCH = 'https://static.readdy.ai/image/ec6c134e43b902bc81c674ec061ba5f4/6df1496425e3bb9b3dc7525aebd95109.png';
const LIGHTBOX_IMAGE_EMOTE = 'https://static.readdy.ai/image/ec6c134e43b902bc81c674ec061ba5f4/b3c3615efb513d70b9e3525a1a2036e2.png';

function applyVtuberFont(text: string) {
  const parts = text.split(/(VTubers?)/g);
  return (
    <>
      {parts.map((part, i) =>
        /^VTubers?$/.test(part) ? (
          <span key={i} className="san-brainy">{part}</span>
        ) : (
          part
        )
      )}
    </>
  );
}

export default function WorksSection() {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxSrc, setLightboxSrc] = useState('');
  const [lightboxAlt, setLightboxAlt] = useState('');

  const projects = [
    {
      title: 'VTuberローンチパック',
      category: 'ブランドアイデンティティ',
      description: 'デビュー配信用のロゴ、オーバーレイ、ソーシャルメディアアセットを含む完全なブランディングパッケージ',
      image: 'https://static.readdy.ai/image/ec6c134e43b902bc81c674ec061ba5f4/8d9969c026d000d93554251d14de5669.png',
      link: '#',
      objectPosition: '100% 0%',
      isLightbox: true,
      lightboxImage: LIGHTBOX_IMAGE_VTUBER,
    },
    {
      title: '配信オーバーレイスイート',
      category: 'UIデザイン',
      description: 'チャットボックス、アラート、インタラクティブ要素を備えた動的アニメーションオーバーレイ',
      image: 'https://static.readdy.ai/image/ec6c134e43b902bc81c674ec061ba5f4/390edd7a36c5e717c912219260e531a3.png',
      link: '#',
      objectPosition: 'top center',
    },
    {
      title: 'キャラクターモデルシート',
      category: 'キャラクターデザイン',
      description: 'リギング用の表情とポーズバリエーションを含む完全なキャラクターターンアラウンド',
      image: 'https://static.readdy.ai/image/ec6c134e43b902bc81c674ec061ba5f4/32d36a7efa3bb6a3b5587cc1e9e30d7b.jpeg',
      link: '#',
      objectPosition: 'top center',
      isLightbox: true,
      lightboxImage: LIGHTBOX_IMAGE,
    },
    {
      title: 'サムネイルテンプレート',
      category: 'マーケティング',
      description: 'YouTubeとソーシャルプラットフォーム向けに最適化された高CTRサムネイルデザイン',
      image: 'https://storage.readdy-site.link/project_files/ad497236-385f-4b6e-bb69-bc2f03e1f0bd/a2f2867d-d742-478b-ba01-fd695a7f1532_thumbnail_letsplay.webp?v=03e3d482970da0ee2433f9d1468ae5cb',
      link: '#',
      objectPosition: 'top center',
      isLightbox: true,
      lightboxImage: LIGHTBOX_IMAGE_THUMBNAIL,
    },
    {
      title: 'グッズコレクション',
      category: '印刷デザイン',
      description: 'アクリルスタンド、ステッカー、アパレル用の印刷対応デザイン',
      image: 'https://static.readdy.ai/image/ec6c134e43b902bc81c674ec061ba5f4/2e846e6ff565a8b79da440d97a4fe3a1.jpeg',
      link: '#',
      objectPosition: 'top center',
      isLightbox: true,
      lightboxImage: LIGHTBOX_IMAGE_MERCH,
    },
    {
      title: 'エモートパックバンドル',
      category: 'デジタルアセット',
      description: 'Twitch、Discord、YouTubeメンバーシップ用のカスタムエモートセット',
      image: 'https://static.readdy.ai/image/ec6c134e43b902bc81c674ec061ba5f4/17d65152852edbc348b520f87e14c322.jpeg',
      link: '#',
      objectPosition: 'top center',
      isLightbox: true,
      lightboxImage: LIGHTBOX_IMAGE_EMOTE,
    },
  ];

  return (
    <section id="works-section" className="py-32 bg-gray-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: 'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="1"%3E%3Cpath d="M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")'
      }}></div>

      <div className="max-w-7xl mx-auto px-8 relative z-10">
        <div className="flex items-center justify-between mb-16">
          <div>
            <h2 className="text-5xl font-bold text-white mb-2">厳選プロジェクト</h2>
            <div className="w-48 h-1 bg-gradient-to-r from-pink-500 to-cyan-500 rounded-full"></div>
          </div>
        </div>

        <div className="mb-12 bg-gradient-to-r from-pink-500/10 to-purple-500/10 border-l-4 border-pink-500 rounded-lg p-6 backdrop-blur-sm">
          <div className="flex items-start gap-4">
            <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
              <i className="ri-information-line text-2xl text-pink-400"></i>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-white mb-2">ポートフォリオ免責事項</h3>
              <p className="text-sm text-gray-300 leading-relaxed">
                ここに掲載されているプロジェクトは、私のプロフェッショナルな仕事とデザイン能力を表しています。一部の作品はNDAまたはクライアントとの機密保持契約の対象となっている場合があります。すべての知的財産権はそれぞれの所有者に帰属します。これらの例は、ポートフォリオのデモンストレーション目的でのみ表示されています。
              </p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mb-16">
          {projects.map((project, index) => {
            const isLightbox = (project as any).isLightbox;
            return isLightbox ? (
              <button
                key={index}
                onClick={() => {
                  setLightboxSrc((project as any).lightboxImage || LIGHTBOX_IMAGE);
                  setLightboxAlt(project.title);
                  setLightboxOpen(true);
                }}
                className="group relative rounded-3xl overflow-hidden cursor-pointer block text-left w-full"
              >
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    style={{ objectPosition: project.objectPosition }}
                    loading="lazy"
                    decoding="async"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-7 backdrop-blur-sm bg-black/40">
                    <span className="inline-block text-xs uppercase tracking-wider text-cyan-400 bg-cyan-400/20 px-3 py-1 rounded-full mb-3">
                      {project.category}
                    </span>
                    <h3 className="text-2xl font-bold text-white mb-2">{applyVtuberFont(project.title)}</h3>
                    <p className="text-sm text-gray-300 leading-relaxed">{project.description}</p>
                  </div>
                  <div className="absolute top-6 right-6 w-10 h-10 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center opacity-60 group-hover:opacity-100 transition-opacity">
                    <i className="ri-zoom-in-line text-white text-lg"></i>
                  </div>
                </div>
                <div className="absolute inset-0 border-2 border-transparent group-hover:border-pink-500 rounded-3xl transition-all duration-300 pointer-events-none"></div>
              </button>
            ) : (
              <a
                key={index}
                href={project.link}
                className="group relative rounded-3xl overflow-hidden cursor-pointer block"
              >
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    style={{ objectPosition: project.objectPosition }}
                    loading="lazy"
                    decoding="async"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-7 backdrop-blur-sm bg-black/40">
                    <span className="inline-block text-xs uppercase tracking-wider text-cyan-400 bg-cyan-400/20 px-3 py-1 rounded-full mb-3">
                      {project.category}
                    </span>
                    <h3 className="text-2xl font-bold text-white mb-2">{applyVtuberFont(project.title)}</h3>
                    <p className="text-sm text-gray-300 leading-relaxed">{project.description}</p>
                  </div>
                  <div className="absolute top-6 right-6 w-10 h-10 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center opacity-60 group-hover:opacity-100 transition-opacity">
                    <i className="ri-external-link-line text-white text-lg"></i>
                  </div>
                </div>
                <div className="absolute inset-0 border-2 border-transparent group-hover:border-pink-500 rounded-3xl transition-all duration-300 pointer-events-none"></div>
              </a>
            );
          })}
        </div>

        <div className="text-center">
          <a
            href="https://www.behance.net/daniellozano25"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-lg font-medium text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-cyan-400 hover:from-pink-300 hover:to-cyan-300 transition-all cursor-pointer"
          >
            Behanceで全ポートフォリオを見る
            <i className="ri-arrow-right-line text-xl text-pink-400"></i>
          </a>
        </div>
      </div>

      {/* Lightbox */}
      {lightboxOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-sm"
          onClick={() => setLightboxOpen(false)}
        >
          <button
            className="absolute top-6 right-6 w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors cursor-pointer"
            onClick={() => setLightboxOpen(false)}
          >
            <i className="ri-close-line text-white text-2xl"></i>
          </button>
          <div
            className="max-w-5xl max-h-[90vh] w-full mx-6"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={lightboxSrc}
              alt={lightboxAlt}
              className="w-full h-full object-contain rounded-xl shadow-2xl"
              style={{ maxHeight: '90vh' }}
            />
          </div>
        </div>
      )}
    </section>
  );
}
